/**
 * insights-admin SPA entrypoint.
 *
 * Mounts the Vue app at `#app`, wires the router, imports the global
 * design tokens + chrome stylesheets (shared with dashboard-app), and
 * registers `<lucent-insight>` as a custom element so Vue doesn't try
 * to resolve it as a component. The runtime bundle itself is loaded
 * on demand from `InsightView.vue` — admins only mount the Web
 * Component when opening an insight-detail page, so eager-bootstrap
 * (the dashboard's pattern) would be wasted bandwidth.
 */

import { createApp } from "vue";
import App from "./App.vue";
import { router } from "./router.ts";

// Global styles, shared with dashboard-app via `@lucent/ui` — one source of
// truth rather than two copies that drift. `tokens.css` first: `chrome.css`
// reads its custom properties, and an undefined one invalidates the whole
// declaration rather than falling back.
import "@lucent/ui/styles/tokens.css";
import "@lucent/ui/styles/chrome.css";
// Admin-only content primitives — tables, badges, filter bars, tabs, readouts.
// These stay local until Phase 2 of docs/plans/admin-clients-ux.md dissolves
// them into components in the shared package.
import "./styles/chrome.css";

const app = createApp(App);
app.use(router);

// Custom-element tags must be ignored by Vue's compiler so it
// doesn't try to resolve `lucent-insight` as a Vue component.
app.config.compilerOptions ??= {};
app.config.compilerOptions.isCustomElement = (tag) => tag === "lucent-insight";

app.mount("#app");
